import HeliosFAQSection from './FAQSection';

export default HeliosFAQSection;
